/**
 * @generated SignedSource<<22c19159d9b6fa9396edad8392a448c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelEditTabs_hotel$data = {
  readonly media: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly rooms: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"EntityHistory_entity" | "HotelEditMain_hotel" | "HotelEditRooms_hotel" | "MediaEditor_mediable">;
  readonly " $fragmentType": "HotelEditTabs_hotel";
};
export type HotelEditTabs_hotel$key = {
  readonly " $data"?: HotelEditTabs_hotel$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditTabs_hotel">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "search"
    },
    {
      "kind": "RootArgument",
      "name": "sort"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelEditTabs_hotel",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2147483647
        }
      ],
      "concreteType": "MediaConnection",
      "kind": "LinkedField",
      "name": "media",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "media(first:2147483647)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "sort",
          "variableName": "sort"
        }
      ],
      "concreteType": "RoomConnection",
      "kind": "LinkedField",
      "name": "rooms",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HotelEditMain_hotel"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MediaEditor_mediable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityHistory_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HotelEditRooms_hotel"
    }
  ],
  "type": "Hotel",
  "abstractKey": null
};
})();

(node as any).hash = "6daf1da393162d1de94f89052226c8b7";

export default node;
